import React from "react";
import UIModal from "UIComponents/UIModal";
import I18nHOC from "UIComponents/I18nHOC";
import { compose } from "lib/apolloClient";
import { Avatar, Button } from "@toddle-edu/ds-web";
import classes from "./ChildConnectionSuccess.scss";
import classNames from "classnames";

const ChildConnectionSuccess = ({ onClose, t, profileImage, studentName }) => {
  const headingStyles = classNames({
    "heading-4": true,
    [classes.heading]: true,
  });

  return (
    <UIModal
      isOpen={true}
      onRequestClose={onClose}
      modalContent={classes.modalContent}
    >
      <div className={classes.container}>
        <Avatar
          src={profileImage}
          className={classes.avatar}
          size="medium"
        ></Avatar>

        <div className={headingStyles}>
          {t("common:view_student_classwork", { studentName })}
        </div>
        <div className="text-label-2">
          {t("common:view_student_classword_subheading", {
            studentName,
          })}
        </div>
        <Button className={classes.doneBtn} onClick={onClose}>
          {t("common:done")}
        </Button>
      </div>
    </UIModal>
  );
};

export default compose(
  I18nHOC({
    resource: ["common"],
  })
)(ChildConnectionSuccess);
